import { BreadcrumbDropdown } from '@dealstack/frontend/shared/components/BreadcrumbDropdown';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { DataGeneratableDocumentTemplateWithAllRelationsTct } from '@dealstack/shared/lib/generated';
import { useLocation, useNavigate } from 'react-router-dom';
import { MantineMenuItemProps } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.types';
import { generatableDocumentEditPath } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/ManageGeneratableDocuments.utils.ts';

interface Props {
	documentsTemplates?: DataGeneratableDocumentTemplateWithAllRelationsTct[];
}

export const GeneratableDocumentsDropdown = ({ documentsTemplates }: Props) => {
	const navigate = useNavigate();
	const location = useLocation();

	const currentTemplateType = documentsTemplates?.find((doc) =>
		location.pathname.includes(doc.id)
	);

	const items: MantineMenuItemProps[] | undefined = documentsTemplates?.map((doc) => {
		const isSelected = doc.type === currentTemplateType?.type;
		return {
			key: doc.id,
			label: doc.type,
			dataTestId: doc.name,
			className: isSelected ? 'selected' : '',
			onClick: () => navigate(generatableDocumentEditPath(doc.id)),
			rightSection: isSelected ? <Icon variant="tick" size="lg" /> : undefined,
		};
	});

	const targetHref = generatableDocumentEditPath(currentTemplateType?.id ?? '');

	return (
		<BreadcrumbDropdown
			targetHref={targetHref}
			targetTitle={currentTemplateType?.type ?? ''}
			items={items}
			breadcrumbType="documents"
		/>
	);
};
